import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-[#0A0E27]/95 backdrop-blur-md' : 'bg-transparent'
        }`}
        style={{ height: '80px' }}
      >
        <div className="h-full flex items-center justify-between px-[120px]">
          <div className="flex items-center gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/7fc008d7-8986-4940-b91a-161d97518d08.png" 
              alt="FERAR SH.P.K. Logo" 
              className="h-12 w-auto object-contain"
            />
            <span className="text-white font-medium text-lg tracking-wide">FERAR SH.P.K.</span>
          </div>
          <div className="flex items-center gap-10">
            {['Home', 'About', 'Products', 'Services', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-white font-light text-sm hover:text-purple-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* Sections */}
      <div id="home">
        <Hero />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="products">
        <Products />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}